'use client';

import { linksHeader } from '@/configs/config.Header';
import { config } from '@/configs/configPortal';
import Link from 'next/link';
import { Key, memo } from 'react';
import './navbar.scss';

interface childrenProps {
    classIcon: string;
    id: string;
    dataQa: string;
    urlAddress: string;
    name: string;
}

const renderMenuAreas = () => {
    return linksHeader?.map((links, index) => {
        return (
            <li
                key={index}
                id={`menu-area-${index}`}
                className={'Menu-User__list-links__navigation__item'}
                data-qa={links.dataQa}
                data-testid={`menu-area-${index}`}
            >
                {links?.area}
                <div
                    className={
                        'Menu-User__list-links__navigation__item__container Menu-User__list-links__navigation__item__container'
                    }
                    id={`menu-area-container-${index}`}
                    data-testid={`menu-area-container-${index}`}
                >
                    <ul
                        className={'Menu-User__list-links__navigation__item__sub'}
                        id={`menu-area-sub-${index}`}
                        data-testid={`menu-area-sub-${index}`}
                    >
                        {links?.children?.map((link: childrenProps, childIndex: Key) => {
                            return (
                                <li
                                    key={childIndex}
                                    id={`menu-sub-item-${index}-${childIndex}`}
                                    className={'Menu-User__list-links__navigation__item__sub__item'}
                                    data-testid={`menu-sub-item-${index}-${childIndex}`}
                                >
                                    <Link
                                        className={`icon ${link?.classIcon}${process.env.NEXT_PUBLIC_ENV === 'dev' ? '--local' : ''}`}
                                        id={link?.id}
                                        data-qa={link?.dataQa}
                                        href={link?.urlAddress}
                                        target="_Blank"
                                        rel="noreferrer"
                                        title={link?.name}
                                        data-testid={`menu-link-${index}-${childIndex}`}
                                    >
                                        {link?.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </li>
        );
    });
};

const Navbar = memo(() => {
    const currentUrl = config.urlWebApp;

    return (
        <div id="navbar-container" data-testid="navbar-container">
            <header className="Header" id="header" data-testid="header">
                <div className="right-container" id="right-container" data-testid="right-container">
                    <div id="logo-container" data-testid="logo-container">
                        <Link href={currentUrl} id="logo-link" data-testid="logo-link">
                            <svg viewBox="0 0 145 28" width="145" height="28">
                                <g fill="none" fillRule="evenodd">
                                    <path
                                        d="M138.731 11.402c0-.614.593-.933 1.322-.933.635 0 1.15.246 1.514.677a.432.432 0 0 0 .533.106l1.742-.93a.434.434 0 0 0 .137-.65c-.926-1.186-2.329-1.82-3.926-1.82-2.348 0-4.332 1.297-4.332 3.618 0 4.007 5.883 3.096 5.883 4.758 0 .66-.638.978-1.573.978-.911 0-1.584-.35-1.982-.967a.43.43 0 0 0-.564-.15l-1.8.961a.437.437 0 0 0-.162.615c.893 1.429 2.459 2.205 4.508 2.205 2.44 0 4.584-1.183 4.584-3.642 0-4.189-5.884-3.141-5.884-4.826M130.237 19.494h-1.294a.863.863 0 0 1-.863-.861V14.01a5.84 5.84 0 0 1 5.846-5.834h.001c.474 0 .859.383.859.857v1.3a.858.858 0 0 1-.859.858h-.002a2.822 2.822 0 0 0-2.824 2.82v4.62a.863.863 0 0 1-.864.862M120.471 17.002c-1.733 0-3.078-1.297-3.078-3.141s1.345-3.141 3.078-3.141c1.756 0 3.102 1.297 3.102 3.14 0 1.845-1.346 3.142-3.102 3.142m0-9.15c-3.353 0-6.02 2.617-6.02 6.009 0 3.391 2.667 6.01 6.02 6.01 3.353 0 6.043-2.619 6.043-6.01 0-3.392-2.69-6.01-6.043-6.01M110.009 4.495h-1.216a.862.862 0 0 0-.863.862V15.727c0 2.863 1.206 4.105 4.709 3.895a.866.866 0 0 0 .81-.862v-.98a.865.865 0 0 0-.876-.86c-1.117.007-1.701-.197-1.701-1.193v-4.734h1.714a.862.862 0 0 0 .863-.862v-1.1a.863.863 0 0 0-.863-.86h-1.714V5.356a.863.863 0 0 0-.863-.862M100.26 17.002c-1.733 0-3.078-1.297-3.078-3.141s1.345-3.141 3.078-3.141c1.756 0 3.102 1.297 3.102 3.14 0 1.845-1.346 3.142-3.102 3.142m0-9.15c-3.353 0-6.02 2.617-6.02 6.009 0 3.391 2.667 6.01 6.02 6.01 3.353 0 6.043-2.619 6.043-6.01 0-3.392-2.69-6.01-6.043-6.01M88.383 7.867a4.907 4.907 0 0 0-3.81 1.365 4.908 4.908 0 0 0-3.81-1.365c-2.585.205-4.525 2.465-4.525 5.054v5.914c0 .476.387.861.863.861h1.295a.862.862 0 0 0 .863-.861V12.85c0-.99.724-1.877 1.712-1.974a1.903 1.903 0 0 1 2.092 1.89v6.069c0 .476.385.861.863.861h1.294a.862.862 0 0 0 .864-.861V12.85c0-.99.724-1.878 1.711-1.974 1.134-.11 2.091.78 2.091 1.89v6.069c0 .476.387.861.863.861h1.295a.862.862 0 0 0 .863-.861V12.92c0-2.589-1.94-4.85-4.524-5.054M68.94 16.915c-1.73 0-3.072-1.293-3.077-3.132v-.018c.005-1.839 1.348-3.132 3.078-3.132 1.756 0 3.101 1.298 3.101 3.141 0 1.844-1.345 3.141-3.101 3.141m0-9.15c-1.13 0-2.18.303-3.078.828V4.479A.862.862 0 0 0 65 3.618h-1.216a.862.862 0 0 0-.863.861v9.334h.002c.02 3.372 2.68 5.97 6.018 5.97 3.352 0 6.043-2.617 6.043-6.009 0-3.392-2.69-6.009-6.043-6.009M55.539 10.546c1.228 0 2.254.636 2.76 1.65H52.8c.505-1.014 1.526-1.65 2.739-1.65Zm3.134 5.331c-.318-.17-.72-.138-.98.112-.55.529-1.3.84-2.154.84-1.237 0-2.274-.663-2.767-1.711a.434.434 0 0 1 .387-.626h7.616a.808.808 0 0 0 .807-.805c0-3.391-2.69-6.009-6.043-6.009s-6.02 2.618-6.02 6.01 2.667 6.01 6.02 6.01a6.03 6.03 0 0 0 4.448-1.917c.379-.408.25-1.068-.24-1.33l-1.074-.574ZM45.197 14.783c0 1.11-.958 2-2.092 1.89-.988-.097-1.711-.984-1.711-1.975V8.713a.863.863 0 0 0-.863-.861h-1.295a.862.862 0 0 0-.863.861v5.985c0 .991-.724 1.878-1.712 1.974a1.903 1.903 0 0 1-2.092-1.889v-6.07a.862.862 0 0 0-.863-.861h-1.295a.863.863 0 0 0-.863.861v5.915c0 2.588 1.94 4.849 4.525 5.053a4.908 4.908 0 0 0 3.81-1.364 4.907 4.907 0 0 0 3.81 1.364c2.584-.204 4.525-2.465 4.525-5.053V8.713a.863.863 0 0 0-.863-.861H46.06a.863.863 0 0 0-.863.861v6.07Z"
                                        fill="#151918"
                                    ></path>
                                    <path
                                        d="M13.891 0C6.22 0 .001 6.208.001 13.866c0 7.658 6.219 13.866 13.89 13.866 7.672 0 13.89-6.208 13.89-13.866C27.782 6.208 21.564 0 13.892 0Z"
                                        fill="#F51344"
                                    ></path>
                                    <path
                                        d="M21.656 18.476c0 .655-.548 1.181-1.211 1.146-.622-.032-1.088-.59-1.088-1.21v-2.536a.862.862 0 0 0-.863-.862h-2.59a.862.862 0 0 0-.863.862v3.462c0 .655-.549 1.18-1.212 1.146-.621-.033-1.087-.59-1.087-1.211v-3.397a.863.863 0 0 0-.864-.862H9.29a.862.862 0 0 0-.863.862v2.6c0 .655-.549 1.181-1.212 1.146-.622-.032-1.088-.59-1.088-1.21V9.255c0-.654.548-1.181 1.211-1.146.623.032 1.09.59 1.09 1.211v2.535c0 .476.385.862.862.862h2.59a.863.863 0 0 0 .863-.862V8.394c0-.654.548-1.18 1.21-1.146.623.032 1.09.59 1.09 1.211v3.397c0 .476.385.862.862.862h2.59a.862.862 0 0 0 .863-.862V9.321c0-.622.466-1.179 1.088-1.211a1.149 1.149 0 0 1 1.211 1.146v9.22Z"
                                        fill="#FFF"
                                    ></path>
                                </g>
                            </svg>
                        </Link>
                    </div>
                </div>

                <nav className="Menu" id="menu" data-testid="menu">
                    <div className="Menu-User__list-links" id="menu-user-list-links" data-testid="menu-user-list-links">
                        <ul
                            className="Menu-User__list-links__navigation"
                            id="menu-user-navigation"
                            data-testid="menu-user-navigation"
                        >
                            {renderMenuAreas()}
                        </ul>
                    </div>
                </nav>

                <nav className="Menu" id="menu-right" data-testid="menu-right">
                    <Link
                        id="irWebmotors"
                        className="Menu__link__right"
                        target="_blank"
                        href={currentUrl}
                        data-testid="irWebmotors"
                    >
                        Ir para a Webmotors
                    </Link>
                </nav>
            </header>
        </div>
    );
});

export default Navbar;
